import React from "react"
import { cn } from "@/lib/utils"

export interface TypographyProps extends React.HTMLAttributes<HTMLElement> {
  variant?:
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "body1"
    | "body2"
    | "caption"
    | "overline"
    | "subtitle1"
    | "subtitle2"
  component?: React.ElementType
}

const variantClasses = {
  h1: "text-5xl font-bold leading-tight text-foreground",
  h2: "text-4xl font-bold leading-tight text-foreground",
  h3: "text-3xl font-semibold leading-snug text-foreground",
  h4: "text-2xl font-semibold leading-snug text-foreground",
  h5: "text-xl font-semibold leading-snug text-foreground",
  h6: "text-lg font-semibold leading-normal text-foreground",
  body1: "text-base leading-normal text-foreground",
  body2: "text-sm leading-normal text-foreground",
  caption: "text-xs leading-normal text-muted-foreground",
  overline: "text-xs uppercase tracking-wider leading-normal text-muted-foreground",
  subtitle1: "text-base leading-normal text-foreground",
  subtitle2: "text-sm leading-normal text-muted-foreground",
}

export const Typography: React.FC<TypographyProps> = ({
  variant = "body1",
  component,
  className,
  children,
  ...props
}) => {
  const defaultComponent = variant.startsWith("h") ? variant : "p"
  const Component = (component || defaultComponent) as React.ElementType

  return (
    <Component
      className={cn(variantClasses[variant], className)}
      {...props}
    >
      {children}
    </Component>
  )
}

export default Typography
